if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const giftCardFields = this.closest("product-info")?.querySelector(
          "gift-card-fields"
        );
        if (giftCardFields) {
          giftCardFields.updateFields();
          if (!this.form.reportValidity()) return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        let productGroup =
          this.closest(".product")?.querySelector("product-group");

        if (productGroup) {
          let productGroupCurrent = productGroup.dataset.selectedType;
          let productGroupCurrentItem = productGroupCurrent.split(":");
          let productGroupType = productGroupCurrentItem[0].trim();
          let productGroupData = productGroupCurrentItem[1].trim();

          formData.set(`[properties][${productGroupType}]`, productGroupData);
        }

        if (giftCardFields) {
          this.addToCart(formData, giftCardFields.getItems(formData));
          return;
        }

        const personalisation = document.querySelector(
          ".js-personalisation-form"
        );
        if (personalisation && personalisation.classList.contains("active")) {
          const variantOverride = personalisation.getAttribute(
            "data-personalisation-variant"
          );
          const variantId = document.querySelector(
            "product-form form input[name='id']"
          ).value;
          const quantity =
            parseFloat(
              document.querySelector("product-info input[name='quantity']")
                .value
            ) ?? 1;
          const personalisationFields = document.querySelectorAll(
            ".js-personalisation-field input"
          );

          const countyField = document.querySelector(".js-county");

          let itemsToAdd = [];

          let county = null;
          if (countyField) {
            county = countyField.options[countyField.selectedIndex]?.text || "";
          }

          for (let index = 0; index < quantity; index++) {
            const element = personalisationFields[index].value;
            let properties = { WavePersonalisation: element };
            if (variantOverride) {
              properties["Personalisation Item"] =
                personalisation.getAttribute("data-product-title");
              properties["_PersonalisationID"] = variantId;
            }
            if (county) {
              properties["County"] = county;
            }
            itemsToAdd.push({
              id: variantOverride ? variantOverride : variantId,
              quantity: 1,
              properties: properties,
            });
          }

          if (variantOverride) {
            for (let index = 0; index < quantity; index++) {
              itemsToAdd.push({
                id: variantId,
                quantity: 1,
              });
            }
          }

          fetch(`${routes.cart_add_url}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: itemsToAdd,
            }),
          })
            .then((response) => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "personalisation",
                productVariantId: variantId,
              });
              this.cart.renderContents(response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
            });
        } else {
          this.addToCart(formData);
        }
      }

      addToCart(formData, items) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        config.body = formData;
        if (items) {
          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify({
            items,
            sections: formData.get("sections"),
            sections_url: formData.get("sections_url"),
          });
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || response.message);
              // Recipient validation errors must allow the customer to correct and retry.
              if (items) return;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          if (typeof errorMessage === "object") {
            this.errorMessage.textContent = Object.entries(errorMessage)
              .map(([field, messages]) => `${field}: ${[].concat(messages).join(", ")}`)
              .join(". ");
          } else {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    }
  );
}
